import React, { useState, useEffect } from "react";
import Button from "react-bootstrap/Button";

const SegmentDivider = () => {
  return <div className="segment-divider mb-0">OR</div>;
};
export default SegmentDivider;
